<a
    [attr.aria-label]="product.title + ', ' + productVariant + (product.price | hCurrency: 'short')"
    [attr.href]="urlRedirect"
    [attr.title]="title"
    class="product-card"
    (click)="productSPARedirect($event)">
    @if (productAsset.url) {
        <h-image-resizer
            [desktopUrl]="productAsset.url"
            [desktopAlt]="productAsset.title ?? ''"
            [mediaType]="'product_in_grid'"
            [pictureCssClass]="'media-wrap'">
        </h-image-resizer>
    }

    <div class="product-infos">
        <span class="product-name">{{ product.title }}</span>
        <span hSrOnlyNoSnippet i18n="@@hermes.accessibility.comma-separator">,&nbsp; </span>
        <h-price class="product-price" [size]="'small'" [price]="product.price" [format]="'short'"> </h-price>
    </div>
</a>
